import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { viewPdf } from '../../services/api/admin';
import { GetLocalStorageParsed } from '../../Utils/Utils';

const PdfViewer = () => {
  const { folder1, folder2, folder3, fileName } = useParams();
  var userDetail = GetLocalStorageParsed("userDetail") || {};

  const [pdfUrl, setPdfUrl] = useState(null); // State to hold PDF Blob URL
  const [loading, setLoading] = useState(true); // To show loading state
  const [error, setError] = useState(null); // For error handling

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const formData = new FormData();
        formData.append("district_id", userDetail?.district ?? "");
        const pdfResponse = await viewPdf(fileName, folder1, folder2, folder3 ?? "null", formData);

        if (pdfResponse) {
          const blob = new Blob([pdfResponse], { type: 'application/pdf' });
          const pdfBlobUrl = URL.createObjectURL(blob);
          setPdfUrl(pdfBlobUrl);
        }
      } catch (err) {
        setError("Error fetching the PDF");
      } finally {
        setLoading(false); // Set loading state to false when finished
      }
    };

    // Fetch PDF when fileName is available
    if (fileName) {
      fetchPdf();
    }
  }, [fileName]);

  if (loading) {
    return <div>Loading PDF...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      {pdfUrl ? (
        <object 
          data={pdfUrl} 
          type="application/pdf" 
          width="100%" 
          height="100vh"
          style={{minHeight: "100vh"}}>
        </object>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default PdfViewer;
